exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__dialogRoot___3ViMQ {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-wrap: wrap;\r\n      flex-wrap: wrap;\r\n  -ms-flex-pack: distribute;\r\n      justify-content: space-around;\r\n}\r\n.style__dialogWrapper___2ksU1{\r\n  padding-top: 0 !important;\r\n}\r\n", "", {"version":3,"sources":["/./components/ConfigurationDialog/style.css"],"names":[],"mappings":"AAAA;EACE,qBAAc;EAAd,qBAAc;EAAd,cAAc;EACd,oBAAgB;MAAhB,gBAAgB;EAChB,0BAA8B;MAA9B,8BAA8B;CAC/B;AACD;EACE,0BAA0B;CAC3B","file":"style.css","sourcesContent":[".dialogRoot {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-around;\r\n}\r\n.dialogWrapper{\r\n  padding-top: 0 !important;\r\n}\r\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"dialogRoot": "style__dialogRoot___3ViMQ",
	"dialogWrapper": "style__dialogWrapper___2ksU1"
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader?modules&sourceMap&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!../~/postcss-loader!./components/ConfigurationDialog/style.css
 ** module id = 1048
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader?modules&sourceMap&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!../~/postcss-loader!./components/ConfigurationDialog/style.css
 ** module id = 1048
 ** module chunks = 1
 **/